import { token } from '@atlaskit/tokens';

import AgentsLeftDesktop from '../../../../assets/images/Agents_hero_left_desktop.svg';
import AgentsRightDesktop from '../../../../assets/images/Agents_hero_right_desktop.svg';
import AgentsTabletMobile from '../../../../assets/images/Agents_hero_tablet_mobile.svg';

const AgentsHeroHeadingStyle: React.CSSProperties = {
  marginBottom: token('space.300'),
};

const HeroSectionConfig = {
  heading: 'Supercharge your teams with human-AI collaboration',
  isSearchBarIncluded: false,
  heroDesktopLeftImage: AgentsLeftDesktop,
  heroDesktopRightImage: AgentsRightDesktop,
  heroTabletImage: AgentsTabletMobile,
  heroMobileImage: AgentsTabletMobile,
  buttonLabel: 'Explore apps',
  buttonHref: '/collections/ai-and-rovo',
  headingStyles: AgentsHeroHeadingStyle,
  buttonAriaLabel: 'Explore apps with AI capabilities',
};

export default HeroSectionConfig;
